// types
import { IOption } from 'components/FormElements/Select'
import { IPlanColumn } from 'types/plan/columns'

// Column keys stored in `Plan.columnSettings` — also the keys of the cell renderers.
export const PLAN_COLUMN_IDS = {
  STATUS: 'status',
  DUE: 'due',
  COMMENCEMENT_AT: 'commencementAt',
  ACTUAL_COMPLETION_DATE: 'actualCompletionDate',
  COMPLETION_PERCENTAGE: 'completionPercentage',
  REVIEW: 'review',
  NEXT_REVIEW: 'nextReview',
  ASSIGNEE: 'assignee',
  TOTAL_RESOURCE_BUDGET: 'totalResourceBudget',
  TOTAL_RESOURCE_COST: 'totalResourceCost'
}

// Every column the plan table can show — the source list for the column select.
export const PLAN_COLUMN_OPTIONS: IOption[] = [
  { label: 'Status', value: PLAN_COLUMN_IDS.STATUS },
  { label: 'Due', value: PLAN_COLUMN_IDS.DUE },
  { label: 'Start Date', value: PLAN_COLUMN_IDS.COMMENCEMENT_AT },
  { label: 'Date Complete', value: PLAN_COLUMN_IDS.ACTUAL_COMPLETION_DATE },
  { label: '% Complete', value: PLAN_COLUMN_IDS.COMPLETION_PERCENTAGE },
  { label: 'Review', value: PLAN_COLUMN_IDS.REVIEW },
  { label: 'Next Review', value: PLAN_COLUMN_IDS.NEXT_REVIEW },
  { label: 'Assignee', value: PLAN_COLUMN_IDS.ASSIGNEE },
  { label: 'Total Resource Budget', value: PLAN_COLUMN_IDS.TOTAL_RESOURCE_BUDGET },
  { label: 'Total Resource Cost', value: PLAN_COLUMN_IDS.TOTAL_RESOURCE_COST }
]

// Columns the plan table shows when a plan has no column settings of its own.
export const DEFAULT_PLAN_COLUMNS: IPlanColumn[] = [
  { fieldId: PLAN_COLUMN_IDS.DUE },
  { fieldId: PLAN_COLUMN_IDS.REVIEW },
  { fieldId: PLAN_COLUMN_IDS.NEXT_REVIEW },
  { fieldId: PLAN_COLUMN_IDS.ASSIGNEE }
]

export const getPlanColumnLabel = (fieldId: string) =>
  PLAN_COLUMN_OPTIONS.find((option) => option.value === fieldId)?.label || fieldId
